import { useState } from "react";
import { ProductFormType } from "../../ProductForm.types";
import { IngredientsFormGrid } from "./IngredientsFormGrid/IngredientsFormGrid";
import { IngredientsModal } from "./IngredientModal/IngredientsModal";
import { useTheme } from "@mui/material";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";

type Page2Props = {
    product: ProductFormType;
    setProduct: (newProduct: ProductFormType) => void;
};

export const Page2 = (props: Page2Props) => {
    const { product, setProduct } = props;
    const theme = useTheme();
    const [isOpen, setOpen] = useState(false);
    const openModal = () => setOpen(true);

    return (
        <div
            style={{
                paddingTop: theme.spacing(4),
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
            }}
        >
            <IngredientsModal
                productIngredients={product.productIngredients}
                isOpen={isOpen}
                setOpen={setOpen}
                onValidate={(newIngredients) => {
                    setProduct({
                        ...product,
                        productIngredients: newIngredients,
                    });
                }}
            />
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_FORM_INGREDIENTS_HEADER} />
            <IngredientsFormGrid
                ingredients={product.productIngredients}
                productWeight={product.netWeight ?? 0}
                openModal={openModal}
                setProductIngredients={(newProductIngredients) => {
                    setProduct({
                        ...product,
                        productIngredients: newProductIngredients,
                    });
                }}
            />
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_FORM_INGREDIENTS_FOOTER} />
        </div>
    );
};
